module.exports = __webpack_public_path__ + "img/x.f59f68e5.png";